import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import "./BerthsModal.css";
import { BerthCard } from "../card/Card";
// import { SupplierCard } from "../supplier/SupplierCard";

export const BerthsModal = ({ open, handleClose, berths }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="berths-title"
      aria-describedby="berths-description"
    >
      <Box className="SuppliersModal">
        <div className="modalHeader">
          <h3>Available Berths</h3>
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="suppliersContainer">
          {berths?.length === 0 ? (
            <h2 style={{ color: "gray", textAlign: "center" }}>
              <strong>Berths not found in this area range</strong>
            </h2>
          ) : (
            <>
              {berths.map((berth) => {
                return (
                  <div className="cardParent">
                    <BerthCard type="result" data={berth} />
                  </div>
                );
              })}
            </>
          )}
        </div>
      </Box>
    </Modal>
  );
};
